import React from "react";

const columns = [
  {
    Header: "Report Name",
    accessor: "extractName",
    Cell: (value) => {
      return (
        <div data-tag="allowRowEvents" style={{ width: 250 }}>
          {value.row.values.extractName}
        </div>
      );
    },
  },
  {
    Header: "Description",
    accessor: "description",
    Cell: (value) => {
      return (
        <div data-tag="allowRowEvents" style={{ width: 250 }}>
          {value.row.values.description}
        </div>
      );
    },
  },
  {
    Header: "Last Run Status",
    accessor: "lastRunStatus",
    Cell: (value) => {
      return (
        <div
          data-tag="allowRowEvents"
          className={`pilltext pilltext--${value.row.values.lastRunStatus}`}
        >
          {value.row.values.lastRunStatus}
        </div>
      );
    },
  },
  {
    Header: "Next Run Time",
    accessor: "nextRunTime",
    Cell: (value) => {
      return (
        <div
          data-tag="allowRowEvents"
          style={
            value.row.values.nextRunTime === "---"
              ? { display: "flex", justifyContent: "center" }
              : undefined
          }
        >
          {value.row.values.nextRunTime}
        </div>
      );
    },
  },
  {
    Header: "Last Run Time",
    accessor: "lastRunTime",
    Cell: (value) => {
      return (
        <div
          data-tag="allowRowEvents"
          style={
            value.row.values.lastRunTime === "---"
              ? { display: "flex", justifyContent: "center" }
              : undefined
          }
        >
          {value.row.values.lastRunTime}
        </div>
      );
    },
  },
  {
    Header: "Actions",
    accessor: "actions",
    disableSortBy: true,
    Cell: (value) => {
      return (
        <div
          data-tag="allowRowEvents"
          style={{ display: "flex", justifyContent: "center" }}
        >
          {value.row.values.actions}
        </div>
      );
    },
  },
];

export default columns;
